import PostBuyContent from "@/features/BuySuccess/ui/PostBuyContent.jsx";
import {MainLayout} from "@/layouts/main/index.js";

export default function BuySuccessWidget () {
    return (
        <MainLayout>
            <PostBuyContent/>
        </MainLayout>
    )
}